import React, { useEffect, useRef, useState } from "react";
import { Spinner } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import "./app.css";
import GoToTop from "./Components/GotoTop";
import { Routes, Route, Navigate, useLocation, useNavigate } from "react-router-dom";
// import LoginPage from "./Pages/LoginPage";
import { ToastContainer } from "react-toastify";
import NotFoundPage from "./Components/NotFoundPage";
import Dashboard from "./Pages/Dashboard";
import Users from "./Pages/User/Users";
import Setting from "./Pages/Setting/Setting";
import About from "./ComponentsWeb/Main/About";
import Contact from "./ComponentsWeb/Main/Contact";
import UserLogin from "./ComponentsWeb/Main/user/UserLogin";
import VerifyOtp from "./ComponentsWeb/Main/user/forgotpassword/VerifyOtp";
import UserRegister from "./ComponentsWeb/Main/user/UserRegister";
// import AbcChat from "./ComponentsWeb/Main/Chat/Chat";
import Branch from "./Pages/Branch/Branch";
import Message from "./Pages/Message/Message";
import ChatUsers from "./Pages/User/ChatUsers";
import Chat from "./Pages/User/Chat";
import QuickReply from "./Pages/QuickReply/QuickReply";
import BroadcastPage from "./Pages/Broadcast/Broadcast";
import UserProfile from "./ComponentsWeb/Main/user/UserProfile";
import TermsOfService from "./ComponentsWeb/Sub/TermsOfService";
import PrivacyPolicy from "./ComponentsWeb/Sub/PrivacyPolicy";
import ChildSafety from "./ComponentsWeb/Sub/ChildSafety";
import { useDispatch, useSelector } from "react-redux";
import { socketEmit } from "./Socket";
import socket from "./socketInstance";
import { getMyProfile } from "./reducers/commonReducer";
import QuickChat from "./Pages/User/QuickChat";
import UploadedFiles from "./Pages/Message/UploadedFiles";
import { home } from "./const";
import AdminChatUsers from "./Pages/User/AdminChatUsers";
import AdminChat from "./Pages/User/AdminChat";
import AdminGroupChats from "./Pages/User/AdminGroupChats";
import AdminGroupChat from "./Pages/User/AdminGroupChat";
import Notifications from "./Pages/Notifications";
import IosPrivacyPolicy from "./ComponentsWeb/Sub/IosPrivacyPolicy";
import {
  ensureBrowserToken,
} from "./helpers/notificationToken";

const RoleRoute = ({ allowedRoles, children }) => {
  const token = localStorage.getItem("x-auth-token");
  const slug = localStorage.getItem("slug");

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (!allowedRoles.includes(slug)) {
    return <Navigate to="/users" replace />;
  }

  return children;
};

const RequireProfileComplete = ({ children }) => {
  const token = localStorage.getItem("x-auth-token");
  const slug = localStorage.getItem("slug");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { getMyProfileData, getMyProfileError } = useSelector((state) => state.commonReducer);

  // Only enforce for logged-in customers
  if (!token || slug !== "customer") return children;

  // Error loading profile — show retry/login buttons
  if (getMyProfileError) {
    return (
      <div className="text-center p-5">
        <p>Failed to load profile. Please try again.</p>
        <button className="btn btn-primary me-2" onClick={() => dispatch(getMyProfile())}>Retry</button>
        <button className="btn btn-secondary" onClick={() => { localStorage.clear(); navigate('/'); }}>Login</button>
      </div>
    );
  }

  // Still loading profile — show spinner
  if (!getMyProfileData) {
    return <div className="text-center p-5"><Spinner animation="border" /></div>;
  }

  const nameComplete = getMyProfileData?.firstName?.trim();
  if (!nameComplete) {
    return <Navigate to="/user-profile" replace />;
  }

  return children;
};

const ENV_FAVICON = process.env.REACT_APP_SITE_FAVICON;
if (ENV_FAVICON) {
  let link = document.querySelector("link[rel~='icon']");
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }
  link.href = ENV_FAVICON;
}

function App() {
  const location = useLocation();
  const lastLocation = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [socketReady, setSocketReady] = useState(false);

  // useEffect(() => {
  //   const syncNotificationToken = async () => {
  //     try {
  //       const authToken = localStorage.getItem("x-auth-token");

  //       if (!authToken) {
  //         return;
  //       }

  //       const webToken = await ensureBrowserToken();

  //       if (!webToken) {
  //         return;
  //       }

  //       await dispatch(saveUserToken({ webToken })).unwrap();
  //     } catch (error) {
  //       console.error("Failed to sync browser notification token:", error);
  //     }
  //   };

  //   syncNotificationToken();
  // }, [dispatch]);

  //Profile
  useEffect(() => {
    const token = localStorage.getItem('x-auth-token');
    if (token) {
      dispatch(getMyProfile());
    }
  }, [localStorage.getItem('x-auth-token')]);
  
  //Connection save — re-runs save_connection on every connect/reconnect
  useEffect(() => {
    const authToken = localStorage.getItem('x-auth-token');
    const authUserid = localStorage.getItem('userid');
    if (!authToken || !authUserid) return;

    const handleConnect = async () => {
      try {
        const resp = await socketEmit("save_connection", { userid: authUserid, token: authToken });
        if (resp?.status === 1) {
          setSocketReady(true);
          localStorage.setItem("socketid", socket.id);
        } else if (resp?.code === "invalid_session") {
          localStorage.clear();
          window.location.href = "/";
        }
      } catch (err) {
        console.error("❌ save_connection error:", err);
      }
    };

    const handleDisconnect = () => {
      setSocketReady(false);
    };

    const handleForceLogout = () => {
      localStorage.clear();
      window.location.href = "/";
    };

    // Use .on (not .once) so reconnects also trigger save_connection
    socket.on("connect", handleConnect);
    socket.on("disconnect", handleDisconnect);
    socket.on("connect_error", (err) => console.error("❌ Connection error:", err.message));
    socket.on("force_logout", handleForceLogout);

    if (!socket.connected) {
      socket.connect();
    } else {
      // Already connected from a previous render — register right away
      handleConnect();
    }

    return () => {
      socket.off("connect", handleConnect);
      socket.off("disconnect", handleDisconnect);
      socket.off("force_logout", handleForceLogout);
    };
  }, [
    localStorage.getItem('x-auth-token'),
    localStorage.getItem('userid'),
  ]);  

  //Get Last location
  useEffect(() => {
    if (lastLocation.current) {
      localStorage.setItem('lastLocation', lastLocation.current.pathname + lastLocation.current.search);
    }
    if(localStorage.getItem("userStatus") === "false"){
      navigate('/');
      localStorage.clear();
    }
    lastLocation.current = location;
  }, [location]);
  //this console is for mobile app
  console.log("x-auth-token", localStorage.getItem("x-auth-token"))
  return (
    <>
      <Routes>
        {/* web routes start*/}
        <Route path="/" element={<UserRegister />} />
        <Route path="/verify-otp" element={<VerifyOtp />} />
        <Route path="/user-profile" element={<UserProfile />} />
        {/* <Route path="/abc" element={<AbcChat />} /> */}




        <Route path="/about" element={<About />} />
        <Route path="/login" element={<UserLogin />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/term-and-conditions" element={<TermsOfService />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/privacy-policy-ios-app" element={<IosPrivacyPolicy/>} />
        <Route path="/child-safety" element={<ChildSafety />} />
        {/* web routes end*/}
        {/* <Route path="/admin-login" element={<LoginPage />} /> */}
        {/* <Route path={`/dashboard`} element={<PrivateRoute allowedRoles={["admin"]}><Dashboard /></PrivateRoute>} />
        <Route path={`/branchs`} element={<PrivateRoute allowedRoles={["admin"]}><Branch /></PrivateRoute>} />
        <Route path={`/quick-reply`} element={<PrivateRoute allowedRoles={["admin"]}><QuickReply /></PrivateRoute>} /> */}
        <Route path="/dashboard" element={<Dashboard />} />
        <Route
          path="/branchs"
          element={
            <RoleRoute allowedRoles={["admin"]}>
              <Branch />
            </RoleRoute>
          }
        />
        <Route path="/quick-reply" element={<QuickReply />} />
        <Route path="/broadcast" element={<BroadcastPage />} />
        <Route path="/messages" element={<Message />} />
        <Route
          path="/uploaded-files"
          element={
            <RoleRoute allowedRoles={["admin"]}>
              <UploadedFiles />
            </RoleRoute>
          }
        />
        <Route path="/notifications" element={<Notifications />} />
        <Route path="/users" element={<Users />} />
        <Route path="/quick-chat" element={<QuickChat />} />
        <Route path="/chat-users" element={<RequireProfileComplete><ChatUsers socketReady={socketReady} /></RequireProfileComplete>} />
        <Route path="/admin-chat-users" element={<AdminChatUsers/>} />
        <Route path="/admin-group-chats" element={<AdminGroupChats/>} />
        <Route path="/agent-to-agent" element={<ChatUsers socketReady={socketReady} />} />
        <Route path="/chat" element={<RequireProfileComplete><Chat socketReady={socketReady} /></RequireProfileComplete>} />
        <Route path="/admin-chat" element={<AdminChat/>} />
        <Route path="/admin-group-chat" element={<AdminGroupChat/>} />
        <Route
          path="/settings"
          element={
            <RoleRoute allowedRoles={["admin"]}>
              <Setting />
            </RoleRoute>
          }
        />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        newestOnTop={false}
        closeOnClick
        theme="colored"
      />
      <GoToTop />
    </>
  );
}
export default App;
